import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, Routes, useNavigate} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"
import {AxiosError} from "axios";
import AuthenticationView from "@/view/auth/AuthenticationView";

import MainView from "@/view/main/MainView";
import Loading from "@/view/common/component/Loading";
import Alert from "@/view/common/popup/Alert"
import {MESSAGE} from "@/common/Constant"
import EmailLoginView from "@/view/login/EmailLoginView"
import SignupView from "@/view/signup/SignupView";



const App: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isOpen2, setIsOpen2] = useState(false)
    const queryClient = new QueryClient(
        {
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    cacheTime: 0, // 시간안에 같은 key로 요청오면 캐싱된 데이터 리턴 1000 -> 1초, default: 0초, 공지사항, FAQ: 1시간(1000 * 60 * 60) 으로 오버라이딩 해서 사용
                    retry: false, // false: 에러시 재시도 없음. 1: 재시도 1회
                    enabled: false, // true: mount시 함수 호출, false mount시 함수 호출 되지 않음
                    onError: (err:unknown) => {
                        const error = err as AxiosError
                        if(error.response !== undefined && (error.response.status === undefined || (error.response.status !== 401 && error.response.status !== 403))){
                            setIsOpen(true)
                        }
                    }
                },
            }
        }
    )

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<AuthenticationView/>}/>
                        <Route path="/login" element={<EmailLoginView/>}/>
                        <Route path="/main" element={<MainView/>}/>
                        <Route path="/loading" element={<Loading/>}/>
                        <Route path="/signup" element={<SignupView/>}/>
                    </Routes>
                </BrowserRouter>
            </QueryClientProvider>
            <Alert content={<div className={'text-center b2_r'}><div>{MESSAGE.ERROR1}</div><div>{MESSAGE.ERROR2}</div></div>} title={undefined} btnContent={'확인'} isOpen={isOpen} onClose={ () => setIsOpen(false)}/>
            <Alert content={<div className={'text-center b2_r'}><div>사용자 인증이 완료되었습니다.</div><div>다시 로그인해 주세요.</div></div>} title={undefined} btnContent={'확인'} isOpen={isOpen2} onClose={ () => setIsOpen2(false)}/>

        </>
    )
}
export default App;
